import styled from 'styled-components';

import { Button } from '@components/button';
import { Card } from '@components/card';
import { IconForm } from '@components/icons/form';
import { IconOpenNewTab } from '@components/icons/open-new-tab';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Tooltip } from '@components/tooltip';
import { useScopedTranslate } from '@locale/translate';
import { lineClamp } from '@styles/layout-helpers';

import { useEditJourneyActionFormOverlay } from './edit-journey-action-form-overlay';
import { useOverlayPreview } from './overlay-preview';

import { TEMPLATE_PREVIEW_BUTTON_CLASSNAME } from '../common';

export const TemplateCardForm = ({
  formId,
  name,
  showPreview,
  isPreviewOnly = false,
  formUrl,
}: {
  formId: string;
  name: string;
  showPreview?: boolean;
  isPreviewOnly?: boolean;
  formUrl?: string;
}) => {
  const showEditJourneyActionFormOverlay = useEditJourneyActionFormOverlay();
  const showOverlayPreview = useOverlayPreview();
  const { t } = useScopedTranslate();

  const handleEditClick = () => {
    showEditJourneyActionFormOverlay({ formId, openPreview: showPreview });
  };

  const handlePreviewClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (formUrl) {
      window.open(formUrl, '_blank');
    } else {
      showOverlayPreview({
        formId,
      });
    }
  };

  return (
    <Card
      interactive={!isPreviewOnly}
      spaceY={2}
      spaceX={4}
      onClick={!isPreviewOnly ? handleEditClick : undefined}
      style={{ cursor: !isPreviewOnly ? 'pointer' : 'default' }}
      dataTestId="form-card"
    >
      <Stack align="center" space={3} orientation="horizontal">
        <IconForm />
        <Tooltip content={name}>
          <NameContainer>
            <Text font="semibold14" text={name} />
          </NameContainer>
        </Tooltip>
        <Stack orientation="horizontal">
          <Button
            className={TEMPLATE_PREVIEW_BUTTON_CLASSNAME}
            dataTestid="preview"
            variant="ghost"
            onClick={handlePreviewClick}
            text={formUrl ? t('core.open') : t('core.preview')}
            iconRight={formUrl ? <IconOpenNewTab size={16} /> : undefined}
          />
        </Stack>
      </Stack>
    </Card>
  );
};

const NameContainer = styled.div({
  flexGrow: 1,
  ...lineClamp('-webkit-box', 3, true),
});
